import React from "react";
import { MultimediaGallery } from "../MultimediaGallery/MultimediaGallery";
import { MediaSwitchDesktop } from "../MediaSwitchDesktop/MediaSwitchDesktop";
import { MultimediaGalleryModalContainer, MobileView, DesktopView, } from "./MultimediaGalleryModalStyled";
export var MultimediaGalleryModal = function (_a) {
    var data = _a.data;
    var product = data.product, imageSelected = data.imageSelected;
    return (React.createElement(MultimediaGalleryModalContainer, null,
        React.createElement(MobileView, null,
            React.createElement(MultimediaGallery, { className: "modalMultimedia", selected: imageSelected, product: product })),
        React.createElement(DesktopView, null,
            React.createElement(MediaSwitchDesktop, { product: product, selected: imageSelected }))));
};
